// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"357":"543ba7904708b364","446":"8224addc8e0e7ec9"}[chunkId] + ".js";
};